import { defineNuxtPlugin, useRuntimeConfig, useRequestHeaders } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  let host = ''
  if (import.meta.client) {
    // 确保只有在客户端环境下访问 window
    host = window.location.host
  } else {
    const headers = useRequestHeaders()
    host = headers.host
  }
  if (import.meta.server) {
    if (host.includes('127.0.0.1:3008')) {
      config.public.apiBase = 'https://shop.kundies.com/api/v1'
      config.public.productBase = 'https://shop.kundies.com/api'
      config.public.country = 'us'
      config.public.currency = 'USD'
      config.public.locale = 'en'
    } else if (host.includes('sedyes.com') || host.includes('127.0.0.1:4002')) {
      config.public.apiBase = 'https://api.sedyes.com/api/v1'
      config.public.productBase = 'https://api.sedyes.com/api'
      config.public.country = 'pl'
      config.public.currency = 'PLN'
      config.public.locale = 'pl'
    } else if (host.includes('kundies.pl') || host.includes('127.0.0.1:3014')) {
      config.public.apiBase = 'https://api.kundies.pl/api/v1'
      config.public.productBase = 'https://api.kundies.pl/api'
      config.public.country = 'pl'
      config.public.currency = 'PLN'
      config.public.locale = 'pl'
    } else if (host.includes('kundies.cz') || host.includes('127.0.0.1:3015')) {
      config.public.apiBase = 'https://api.kundies.cz/api/v1'
      config.public.productBase = 'https://api.kundies.cz/api'
      config.public.country = 'cz'
      config.public.currency = 'CZK'
      config.public.locale = 'cz'
    } else if (host.includes('mqqhot.com') || host.includes('127.0.0.1:4004')) {
      config.public.apiBase = 'https://api.mqqhot.com/api/v1'
      config.public.productBase = 'https://api.mqqhot.com/api'
      config.public.country = 'cz'
      config.public.currency = 'CZK'
      config.public.locale = 'cz'
    } else if (host.includes('tdtopic.com') || host.includes('127.0.0.1:4000')) {
      config.public.apiBase = 'https://api.tdtopic.com/api/v1'
      config.public.productBase = 'https://api.tdtopic.com/api'
      config.public.country = 'ro'
      config.public.currency = 'RON'
      config.public.locale = 'ro'
    } else if (host.includes('hatme.net') || host.includes('127.0.0.1:4001')) {
      config.public.apiBase = 'https://api.hatme.net/api/v1'
      config.public.productBase = 'https://api.hatme.net/api'
      config.public.country = 'hu'
      config.public.currency = 'HUF'
      config.public.locale = 'hu'
    } else if (host.includes('wmbh.net') || host.includes('127.0.0.1:4003')) {
      config.public.apiBase = 'https://api.wmbh.net/api/v1'
      config.public.productBase = 'https://api.wmbh.net/api'
      config.public.country = 'sk'
      config.public.currency = 'EUR'
      config.public.locale = 'sk'
    } else if (host.includes('wmet.net') || host.includes('127.0.0.1:3016')) {
      config.public.apiBase = 'https://api.wmet.net/api/v1'
      config.public.productBase = 'https://api.wmet.net/api'
      config.public.country = 'jp'
      config.public.currency = 'JPY'
      config.public.locale = 'ja'
    } else if (host.includes('127.0.0.1:4005')) {
      config.public.apiBase = 'https://at-api.hatme.de/api/v1'
      config.public.productBase = 'https://at-api.hatme.de/api'
      config.public.country = 'at'
      config.public.currency = 'EUR'
      config.public.locale = 'de'
    } else if (host.includes('127.0.0.1:4006')) {
      config.public.apiBase = 'https://it-api.wmcer.com/api/v1'
      config.public.productBase = 'https://it-api.wmcer.com/api'
      config.public.country = 'it'
      config.public.currency = 'EUR'
      config.public.locale = 'it'
    } else if (host.includes('127.0.0.1:4007')) {
      config.public.apiBase = 'https://es-api.wmcer.com/api/v1'
      config.public.productBase = 'https://es-api.wmcer.com/api'
      config.public.country = 'es'
      config.public.currency = 'EUR'
      config.public.locale = 'es'
    } else if (host.includes('127.0.0.1:5062')) {
      config.public.apiBase = 'https://lt-api.hatme.de/api/v1'
      config.public.productBase = 'https://lt-api.hatme.de/api'
      config.public.country = 'lt'
      config.public.currency = 'EUR'
      config.public.locale = 'lt'
    } else if (host.includes('127.0.0.1:5063')) {
      config.public.apiBase = 'https://si-api.hatme.de/api/v1'
      config.public.productBase = 'https://si-api.hatme.de/api'
      config.public.country = 'si'
      config.public.currency = 'EUR'
      config.public.locale = 'si'
    } else {
      config.public.apiBase = 'https://api.mqqhot.com/api/v1'
      config.public.productBase = 'https://api.mqqhot.com/api'
      config.public.country = 'cz'
      config.public.currency = 'CZK'
      config.public.locale = 'cz'
      // config.public.apiBase = 'https://api.wmet.net/api/v1'
      // config.public.productBase = 'https://api.wmet.net/api'
      // config.public.country = 'jp'
      // config.public.currency = 'JPY'
      // config.public.locale = 'ja'
      // config.public.apiBase = 'https://api.wmbh.net/api/v1'
      // config.public.productBase = 'https://api.wmbh.net/api'
      // config.public.country = 'sk'
      // config.public.currency = 'EUR'
      // config.public.locale = 'sk'
    }
  }

  nuxtApp.hook('app:created', () => {
    const i18n = nuxtApp.vueApp.config.globalProperties.$i18n
    const cookie = useCookie('i18n_redirected')

    if (i18n) {
      i18n.locale = cookie.value || config.public.country
      cookie.value = i18n.locale // 将语言写入 cookie
    }
  })
  nuxtApp.hook('app:mounted', () => {
    const i18n = nuxtApp.vueApp.config.globalProperties.$i18n
    const cookie = useCookie('i18n_redirected')

    if (i18n) {
      i18n.locale = config.public.country
      cookie.value = i18n.locale // 将语言写入 cookie
      nuxtApp.vueApp.config.globalProperties.$forceUpdate?.() // 强制刷新视图
    }
  })
})
